import { render, staticRenderFns } from "./ClQuestion.vue?vue&type=template&id=2856a80a&scoped=true&"
import script from "./ClQuestion.vue?vue&type=script&lang=ts&"
export * from "./ClQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./ClQuestion.vue?vue&type=style&index=0&id=2856a80a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2856a80a",
  null
  
)

export default component.exports